<template>
  <div class="bulk-order-complete__container">
    <div class="bulk-order-complete__header-container mb-16">
      <PageHeadlineForBulkOrder
        title="お申し込み完了"
        :step="4"
        class="bulk-order-complete__header-title"
      />
    </div>
    <div class="bulk-order-complete__contents-container">
      <div class="bulk-order-complete__contents pt-40 pb-24 px-16">
        <div class="bulk-order-complete__eye-catch mb-32">
          <p class="headline-bold mb-16">Thank you!</p>
          <p class="minimal">お申し込みが完了しました</p>
        </div>
        <div class="bulk-order-complete__body mb-24">
          <p class="module-text">
            ご入力いただいたメールアドレス宛てに、お申し込み内容確認メールをお送りしますので、内容のご確認をお願いいたします。
          </p>
          <p class="body-bold">
            ※1日経過してもメールが届かない場合は、
            <a href="/contact/top" target="_blank"> お問い合わせフォーム </a>
            からご連絡いただけますようお願いいたします。
          </p>
          <br />
          <p class="module-text">
            お申し込み内容は、原則2~3営業日以内に確認させていただきます。
          </p>
          <br />
          <p class="module-text">ご連絡まで、今しばらくお待ちください。</p>
        </div>
        <div class="bulk-order-complete__btn-container py-24">
          <ButtonPrimary
            class="bulk-order-complete__btn-to-top"
            text="giftee トップへ戻る"
            @click-primary-button="onClickToTop"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeadlineForBulkOrder from '~/src/js/customer/components/organism/bulk_personal_orders/PageHeadlineForBulkOrder.vue'
import ButtonPrimary from '~/src/js/customer/components/molecules/buttons/ButtonPrimary.vue'
import { useBulkPersonalOrderSessionStore } from '@/src/js/customer/store/bulkPersonalOrderSessionStore'
import { onMounted } from 'vue'

const props = defineProps({
  bulkPersonalOrderId: {
    type: Number,
    required: true
  },
  bulkPersonalOrderSessionId: {
    type: Number,
    required: true
  }
})

const { $reset } = useBulkPersonalOrderSessionStore()

// このページに訪問した時点で store の一時保存情報が不要になるので、全て削除する
$reset()

onMounted(() => {
  dataLayer.push({
    event: 'bulk_order_submitted',
    bulk_personal_order_id: props.bulkPersonalOrderId,
    bulk_personal_order_session_id: props.bulkPersonalOrderSessionId
  })
})

const onClickToTop = () => {
  window.location.href = '/'
}
</script>

<style lang="scss" scoped>
.bulk-order-complete {
  &__header {
    &-container {
      display: flex;
      background-color: $white;
      justify-content: center;
    }

    &-title {
      max-width: $small-contents-width;
      width: 100%;
    }
  }

  &__contents-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $white;
  }

  &__contents {
    max-width: $small-contents-width;
    width: 100%;
    box-sizing: border-box;
  }

  &__body {
    text-align: left;
  }

  &__btn-to-top {
    max-width: 343px;
  }
}
</style>
